<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, sliceId) in data.body"
      :key="sliceId"
      :slice="slice"
    />
  </div>
</template>

<script>
import {
  Hero,
  HighlightSection,
  HighlightIcons,
  SimpleSlice,
  TrustpilotCarousel,
  ProcessArrow,
  SimpleCta,
  FaqSlice,
  LogoList,
} from '@@/shared-slices'

import {
  HighlightBlockSlice,
  SimpleSection,
  FaqSection,
  ArticleSlice,
  BundleProductSlice,
  ArticlesList,
  ScrollableList,
} from '~/components/slices'

import { TextIconSection } from './components'

export default {
  name: 'ProductPageModule',

  components: {
    hero: Hero,
    highlight_section: HighlightSection,
    highlight_block: HighlightBlockSlice,
    highlight_icons: HighlightIcons,
    process_arrow: ProcessArrow,
    text_icon_section: TextIconSection,
    simple_slice: SimpleSlice,
    simple_section: SimpleSection,
    simple_cta: SimpleCta,
    trustpilot_carousel: TrustpilotCarousel,
    article_anchor: ArticleSlice,
    faq_section: FaqSection,
    faq_slice: FaqSlice,
    bundle_product: BundleProductSlice,
    article_list: ArticlesList,
    scrollable_list: ScrollableList,
    logo_list: LogoList,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module></style>
